export const TEST_IDS = {
    integratedComponents: {
        discoveryBarButton: 'ft-test-discovery-bar-book-btn',
        bookingBar: {
            productsSelect: 'ft-test-discovery-booking-bar-products',
            checkinDate: 'ft-test-discovery-booking-bar-checkin',
            checkoutDate: 'ft-test-discovery-booking-bar-checkout',
            roomsSelect: 'ft-test-discovery-booking-bar-rooms',
            childrenSelect: 'ft-test-discovery-booking-bar-children',
            adultsSelect: 'ft-test-discovery-booking-bar-adults',
            nightsSelect: 'ft-test-discovery-booking-bar-nights',
            submit: 'ft-test-discovery-booking-bar-submit',
            checkinCalendarContainer: 'ft-test-discovery-booking-bar-checkin-container',
            checkoutCalendarContainer: 'ft-test-discovery-booking-bar-checkout-container'
        }
    },
    app: {
        root: 'ft-test-discovery-root',
        closeButton: 'ft-test-discovery-close-btn',
        modules: {
            returningUserPopup: {
                container: 'ft-test-discovery-returning-user-popup',
                continueButton: 'ft-test-discovery-returning-user-popup-continue-btn',
                completeButton: 'ft-test-discovery-returning-user-popup-complete-btn',
            },
        },
    },
    overlay: {
        container: 'ft-test-overlay-container',
    },
    router: {
        container: 'ft-test-router-container',
        propertyCard: 'ft-test-router-property-card',
        propertyName: 'ft-test-router-property-name',
        locationCard: 'ft-test-router-location-card',
        locationCards: 'ft-test-router-location-cards',
        bookStayButton: 'ft-test-router-book-stay-btn',
        viewAllButton: 'ft-test-router-view-all-btn',
    },
    planner: {
        container: 'ft-test-planner-container',
        nav: {
            backButton: 'ft-test-planner-nav-back',
            breadcrumbs: 'ft-test-planner-nav-breadcrumbs',
        },
        timeline: {
            rangesBar: 'ft-test-planner-ranges-bar',
            rangeCard: 'ft-test-planner-range-card',
            linearCalendar: 'ft-test-planner-linear-calendar',
            calendarDay: 'ft-test-planner-calendar-day',
            calendarNextBtn: 'ft-test-planner-calendar-next',
            scrollLeft: 'ft-test-planner-calendar-scroll-left',
            scrollRight: 'ft-test-planner-calendar-scroll-right',
        },
        headcount: {
            container: 'ft-test-planner-headcount',
            adultsCounter: 'ft-test-planner-adults-counter',
            childrenCounter: 'ft-test-planner-children-counter',
            roomsCounter: 'ft-test-planner-rooms-counter',
            addChildrenButton: 'ft-test-planner-add-children-btn',
        },
        experiences: {
            container: 'ft-test-planner-experiences',
            card: 'ft-test-planner-experience-card',
        },
        products: {
            container: 'ft-test-planner-products',
            card: 'ft-test-planner-product-card',
        },
        nextButton: 'ft-test-planner-next-btn',
    },
    experienceFirst: {
        container: 'ft-test-experience-first-container',
        gallery: 'ft-test-experience-gallery',
        galleryCard: 'ft-test-experience-gallery-card',
        planStayButton: 'ft-test-experience-plan-stay-btn',
    },
    promoCode: {
        notch: 'ft-test-promo-code-notch',
        input: 'ft-test-promo-code-input',
        submitButton: 'ft-test-promo-code-submit',
        form: 'ft-test-promo-code-form',
    },
    guestStories: {
        carousel: 'ft-test-guest-stories-carousel',
    },
}
